import { render, staticRenderFns } from "./EmployeeGFslips.vue?vue&type=template&id=33436e40"
import script from "./EmployeeGFslips.vue?vue&type=script&lang=js"
export * from "./EmployeeGFslips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports